(function () {
  function initCard(card) {
    var sizeButtons = card.querySelectorAll('[data-pk-size-btn]');
    var cta = card.querySelector('[data-pk-cta]');
    var ctaLabel = cta ? cta.querySelector('[data-pk-cta-label]') : null;
    var variantInput = card.querySelector('[data-pk-variant-input]');
    var form = card.querySelector('form[data-type="add-to-cart-form"]');

    if (!sizeButtons.length || !cta || !variantInput) return;

    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('data-available') === 'false') return;

        sizeButtons.forEach(function (b) {
          b.classList.remove('pk-qa-card__size--selected');
        });
        btn.classList.add('pk-qa-card__size--selected');

        variantInput.value = btn.getAttribute('data-variant-id');

        cta.disabled = false;
        cta.classList.remove('pk-qa-card__cta--disabled');
        cta.classList.add('pk-qa-card__cta--active');
        if (ctaLabel) ctaLabel.textContent = 'Add to cart';
      });
    });

    // Cosmetic feedback only — the actual add-to-cart, cart update,
    // and all downstream events are handled natively by
    // <product-form-component> itself.
    if (form) {
      form.addEventListener('submit', function () {
        if (ctaLabel) ctaLabel.textContent = 'Adding...';
        cta.disabled = true;

        setTimeout(function () {
          if (ctaLabel) ctaLabel.textContent = 'Added';
          cta.classList.add('pk-qa-card__cta--added');

          setTimeout(function () {
            if (ctaLabel) ctaLabel.textContent = 'Add to cart';
            cta.classList.remove('pk-qa-card__cta--added');
            cta.disabled = false;
          }, 1200);
        }, 500);
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-pk-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-pk-card]')) init();
  });
})();